import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

import { useAnchor } from '$contexts/anchor.jsx';
import slugify from '$utilities/slugify.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleAnchorBlock = ({ title }) => {
    const ref = useRef(null);

    const { setCurrent } = useAnchor();

    useEffect(() => {
        if (ref.current && typeof IntersectionObserver === 'function') {
            const handler = entries => {
                if (entries[0].isIntersecting) {
                    setCurrent(entries[0]?.target?.id);
                }
            };

            const observer = new IntersectionObserver(handler, {rootMargin: '0px 0px -80% 0px'});
            observer.observe(ref.current);

            return () => {
                observer.disconnect();
            };
        }
        return () => {};
    }, [ref.current]);

    return (
        <div
            id={slugify(title)}
            ref={ref} />
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    title: PropTypes.string
};

ModuleAnchorBlock.propTypes = propTypes;

export default ModuleAnchorBlock;
